import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import JunoModal from '../common/JunoModal';
import { useState, useEffect } from 'react';
import CustomSwitch from '../common/CustomSwitch';
import { CircularProgress } from '@mui/material';

export default function MobileAdditionalAccounts({
    data,
    loading,
    handleUpdateUser,
    isEdit,
    setSelectedAccount,
}) {
    const [openModal, setOpenModal] = useState(false);
    const [clientEmail, setClientEmail] = useState('');
    const [readOnly, setReadOnly] = useState('');

    useEffect(() => {
        const account = data.find(acc => acc.clientEmail === clientEmail);
        if (account) setReadOnly(!!account.readOnly);
    }, [clientEmail, data]);

    const onClose = () => {
        setOpenModal(false);
    };

    const handleClick = (email, readOnly) => {
        setClientEmail(email);
        setReadOnly(!!readOnly);
        setOpenModal(true);
    };
    return (
        <div>
            {data?.map(account => {
                return (
                    <div
                        className="flex justify-start gap-3 p-3 border-b !border-secondary"
                        onClick={() => handleClick(account.clientEmail, account.readOnly)}
                        key={account._id}>
                        <div className="!bg-secondary rounded-full">
                            <PersonOutlinedIcon
                                className="text-center p-2 invert-0 dark:invert"
                                sx={{ fontSize: 45 }}
                            />
                        </div>
                        <div className="flex flex-col space-y-[5px]">
                            <p className="text-balanceCard-manage text-center">
                                READ ONLY{' '}
                                {account.readOnly ? (
                                    <span className="text-xs bg-[#82B360]/20 dark:bg-[#3CCB7F1F] dark:text-[#3CCB7F] text-#275F00 p-1 mx-2 font-semibold rounded-lg">
                                        ACTIVE
                                    </span>
                                ) : (
                                    <span className="text-xs bg-[#B62B2B29] dark:bg-[#F970661F] dark:text-[#F97066] text-[#5F0000] p-1 rounded-lg mx-2 font-semibold">
                                        INACTIVE
                                    </span>
                                )}
                            </p>
                            <p className="text-md !text-primary uppercase font-semibold">
                                {account.clientEmail}
                            </p>
                        </div>
                    </div>
                );
            })}
            {openModal && !loading && (
                <JunoModal
                    title="ADDITIONAL ACCOUNT"
                    open={openModal}
                    onClose={onClose}
                    content={() => (
                        <MobileAdditionalAccountModal
                            data={data}
                            clientEmail={clientEmail}
                            readOnly={readOnly}
                            handleUpdateUser={handleUpdateUser}
                            loading={loading}
                            isEdit={isEdit}
                            setSelectedAccount={setSelectedAccount}
                            onClose={() => setOpenModal(false)}
                        />
                    )}
                />
            )}
            {loading && data.length ? (
                <div className="bg-text absolute top-0 w-full h-full opacity-25 z-1500 flex justify-center">
                    <CircularProgress className="m-auto" size={50} />
                </div>
            ) : null}
        </div>
    );
}

const MobileAdditionalAccountModal = ({
    handleUpdateUser,
    clientEmail,
    readOnly,
    loading,
    setSelectedAccount,
    onClose,
}) => {
    return (
        <div>
            <div className="flex justify-between py-4 border-b">
                <p className="font-semibold !text-primary py-1 text-center">READ ONLY</p>
                <CustomSwitch
                    checked={readOnly}
                    disable={loading}
                    onClick={() =>
                        handleUpdateUser(
                            {
                                updateEmail: clientEmail,
                                readOnly: !readOnly,
                            },
                            'update',
                        )
                    }
                />
            </div>
            <div>
                <p className="text-sm text-balanceCard-manage py-2">ACCOUNT EMAIL</p>
                <p className="text-md !text-primary font-semibold">{clientEmail}</p>
            </div>
            <div className="flex justify-end gap-2 mt-4">
                <div className="!bg-secondary rounded-lg">
                    <EditOutlinedIcon
                        className=" p-2 cursor-pointer invert-0 dark:invert"
                        sx={{ fontSize: 45 }}
                        onClick={() => {
                            setSelectedAccount({
                                data: { clientEmail, readOnly },
                                action: 'edit',
                            });
                            onClose();
                        }}
                    />
                </div>
                <div className="!bg-secondary rounded-lg">
                    <DeleteOutlinedIcon
                        className="p-2 cursor-pointer invert-0 dark:invert"
                        sx={{ fontSize: 45 }}
                        onClick={() => {
                            setSelectedAccount({
                                data: { clientEmail, readOnly },
                                action: 'delete',
                            });
                            onClose();
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
